import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Icon from 'rv-components-onze/src/Icon';
import Typography from 'rv-components-onze/src/Typography';
import classNames from 'classnames';
import './style.styl';
var buttonStyleMap = {
  primary: 'button--primary',
  outline: 'button--outline',
  'outline-light': 'button--outline-light',
  text: 'button--text',
  'text-light': 'button--text-light'
};
var buttonSizeMap = {
  large: 'button--large',
  small: 'button--small'
};
var buttonLoadingStyleMap = {
  primary: 'button--loading',
  icon: 'button--loading-style-icon'
};

var BaseButton = function BaseButton(_ref) {
  var children = _ref.children,
      as = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "as"]);

  return /*#__PURE__*/React.createElement(as, props, children);
};

var Button = function Button(_ref2) {
  var _classNames;

  var _ref2$as = _ref2.as,
      as = _ref2$as === void 0 ? 'button' : _ref2$as,
      label = _ref2.label,
      isLoading = _ref2.isLoading,
      _ref2$mobileFull = _ref2.mobileFull,
      mobileFull = _ref2$mobileFull === void 0 ? false : _ref2$mobileFull,
      disabled = _ref2.disabled,
      iconId = _ref2.iconId,
      _ref2$iconPosition = _ref2.iconPosition,
      iconPosition = _ref2$iconPosition === void 0 ? 'left' : _ref2$iconPosition,
      _ref2$buttonStyle = _ref2.buttonStyle,
      buttonStyle = _ref2$buttonStyle === void 0 ? 'primary' : _ref2$buttonStyle,
      _ref2$buttonSize = _ref2.buttonSize,
      buttonSize = _ref2$buttonSize === void 0 ? 'large' : _ref2$buttonSize,
      _ref2$loadingStyle = _ref2.loadingStyle,
      loadingStyle = _ref2$loadingStyle === void 0 ? 'primary' : _ref2$loadingStyle,
      _ref2$forceHover = _ref2.forceHover,
      forceHover = _ref2$forceHover === void 0 ? false : _ref2$forceHover,
      _ref2$forceFocus = _ref2.forceFocus,
      forceFocus = _ref2$forceFocus === void 0 ? false : _ref2$forceFocus,
      _ref2$customClass = _ref2.customClass,
      customClass = _ref2$customClass === void 0 ? '' : _ref2$customClass,
      _ref2$radiusFull = _ref2.radiusFull,
      radiusFull = _ref2$radiusFull === void 0 ? false : _ref2$radiusFull,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "label", "isLoading", "mobileFull", "disabled", "iconId", "iconPosition", "buttonStyle", "buttonSize", "loadingStyle", "forceHover", "forceFocus", "customClass", "radiusFull"]);

  var style = classNames('button', "button--icon-" + iconPosition, buttonSizeMap[buttonSize], buttonStyleMap[buttonStyle], customClass, (_classNames = {}, _classNames[buttonLoadingStyleMap[loadingStyle]] = isLoading, _classNames['button--disabled'] = disabled, _classNames['button--hover'] = forceHover, _classNames['button--focus'] = forceFocus, _classNames['button--mobile-full'] = mobileFull, _classNames['button--radius-full'] = radiusFull, _classNames));
  var isDisabled = disabled || isLoading;
  return /*#__PURE__*/React.createElement(BaseButton, Object.assign({}, props, {
    as: as,
    className: style,
    disabled: isDisabled
  }), iconId && /*#__PURE__*/React.createElement(Icon, {
    iconId: iconId
  }), /*#__PURE__*/React.createElement(Typography, {
    as: "span",
    variant: "body2"
  }, label));
};

export default Button;